/**
 *
 * 使用方法：
 *
 * {{ aliyunImgUrl | imgcrop(120, 120) }}
 *
 * */
export function imgcrop(url, width, height,type) {
  if(!url)return ;
  if(!width && !height){return url;}

  let w = width;
  let h = height;
  if(type && type ==1){

  }else{}
  if (url.indexOf('http') === -1 && url.indexOf('https') === -1) {
    //加一个默认地址前缀
    return imgcrop(`https://img.izhaowo.com/${url}`, width, height);
  }
  if(url.indexOf('image.izhaowo.com') >= 0) {
    if(url.indexOf('@') >= 0) return url;
    if(type && type ==1){
      if(h == 'auto'){
        return url + '@'+w+'w_90q_1|watermark=1&&object=5qiq5ZCR5rC05Y2wMi5wbmc&t=100&p=9&x=9&y=9';
      }else{
        return url + '@'+w+'w_'+h+'h_1e_1c_0l|watermark=1&&object=5qiq5ZCR5rC05Y2wMi5wbmc&t=100&p=9&x=9&y=9';
      }
    }else{
      return url + '@'+w+'w_'+h+'h_1e_1c_0l';
    }

  }
  if(url.indexOf('beijing.aliyuncs.com') === -1&&url.indexOf('img.izhaowo.com') === -1)return url;
  if(type && type ==1){
    if(h == 'auto'){
      return url + (url.indexOf('?') === -1 && '?' || '&') + 'x-oss-process=image/resize,m_lfit,w_'+w+'/watermark,image_5qiq5ZCR5rC05Y2wMi5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8xMDA,t_90,g_center,x_10,y_10';
    }else{
      return url + (url.indexOf('?') === -1 && '?' || '&') + 'x-oss-process=image/resize,m_fill,w_'+w+',h_'+h+'/watermark,image_5qiq5ZCR5rC05Y2wMi5wbmc_eC1vc3MtcHJvY2Vzcz1pbWFnZS9yZXNpemUsUF8xMDA,t_90,g_center,x_10,y_10';
    }
  }else{
    if(h == 'auto'){
      return url + (url.indexOf('?') === -1 && '?' || '&') + 'x-oss-process=image/resize,m_lfit,w_'+w;
    }else{
      return url + (url.indexOf('?') === -1 && '?' || '&') + 'x-oss-process=image/resize,m_fill,w_'+w+',h_'+h;
    }

  }
  

}



// WEBPACK FOOTER //
// ./src/plugin/imgcrop.js